import React from "react";
import { Route, Switch } from "react-router-dom";
import { Skeleton } from "antd";

import Summary from "./components/Summary/Summary";
import OwnedPolicies from "./components/OwnedPolicies/OwnedPolicies";
import OwnedPolicyForm from "./components/OwnedPolicyForm/OwnedPolicyForm";
import Attachment from "./components/Attachment/Attachment";

import {
  buildPPSSummaryUri,
  buildPPSOwnedPoliciesUri,
  buildPPSNewOwnedPoliciesUri,
  buildPPSOwnedPolicyDetailsUri,
  buildPPSAttachmentUri,
} from "utils/routes";

const Policies = ({ isLoading, summaryInfo = {} }) => {
  return (
    <Switch>
      <Route path={buildPPSSummaryUri()}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <Summary insurancesInfo={summaryInfo.insuranceSummary} />
        )}
      </Route>
      <Route path={buildPPSNewOwnedPoliciesUri()}>
        <OwnedPolicyForm adviseeInfo={summaryInfo.personalInfo} />
      </Route>
      <Route path={buildPPSOwnedPolicyDetailsUri()}>
        <OwnedPolicyForm adviseeInfo={summaryInfo.personalInfo} />
      </Route>
      <Route path={buildPPSAttachmentUri()}>
        <Attachment />
      </Route>
      <Route path={buildPPSOwnedPoliciesUri()}>
        <OwnedPolicies />
      </Route>
    </Switch>
  );
};

export default Policies;
